import { createSelector } from 'reselect';

import {
  // Utils
  localizedLink,
  // Navigation
  premiumOfferSelector,
  proJobsOfferSelector,
  // Props
  localeSelector,
} from '@xingternal/platform-layout-selectors';

const offerLinksInputSelectors = [
  localeSelector,
  premiumOfferSelector,
  proJobsOfferSelector,
];
const offerLinksTransform = (
  locale,
  premiumOffer,
  proJobsOffer,
  proBusinessOffer
) => {
  return [premiumOffer, proJobsOffer, proBusinessOffer]
    .filter(Boolean)
    .map(localizedLink(locale));
};

const membershipsSelector = createSelector(
  ...offerLinksInputSelectors,
  offerLinksTransform
);

export { membershipsSelector };
